import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

export interface InternalStateType {
  [key: string]: any;
}

export interface StateChangeInterface {
  property: string;
  oldValue: any;
  newValue: any;
}

@Injectable()
export class AppState {
  private _change: Subject<StateChangeInterface> = new Subject();

  public _state: InternalStateType = {
    isMenuActive: false,
    isVideoModalActive: false,
    isLoggedIn: false,
    env: 'staging',
    loading: false,
    appLoaded: false
  };

  constructor() {
    if (window.location.hostname === 'mutzurphantasie.de' || window.location.hostname === 'www.mutzurphantasie.de') {
      this._state.env = 'production';
    } else {
      this._state.env = 'staging';
    }
  }

  public get change(): Observable<StateChangeInterface> {
    return this._change.asObservable();
  }

  /**
   * Already return a clone of the current state.
   */
  public get state() {
    return this._state = this._clone(this._state);
  }
  /**
   * Never allow mutation
   */
  public set state(value) {
    throw new Error('do not mutate the `.state` directly');
  }

  public get env(): string {
    return this.get('env');
  }

  public get(prop?: any) {
    /**
     * Use our state getter for the clone.
     */
    const state = this.state;
    return state.hasOwnProperty(prop) ? state[prop] : state;
  }

  public set(prop: string, value: any) {
    const oldValue = this._state[prop];

    this._state[prop] = value;

    this._change.next({
      property: prop,
      newValue: value,
      oldValue
    });
  }

  private _clone(object: InternalStateType) {
    /**
     * Simple object clone.
     */
    return JSON.parse(JSON.stringify( object ));
  }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts